<template>
  <img src="https://assets.payl8r.com/images/calculator-images/Clock.png" alt="basket">
</template>
<script setup lang="ts">
</script>